export const WC = 'wc';
export const WC_FACILITY = 'wc_facility';
export const WC_NON_FACILITY = 'wc_non_facility';
export const WC_RVU = 'facility_rvu';
export const WC_RVU_NON_FACILITY = 'non_facility_rvu';
export const UCR = 'ucr';
export const MEDICARE_ALLOWED = 'medicare_allowed';
export const MEDICARE_BILLED = 'medicare_billed';
export const MAR = 'mar';
export const URBAN_MAR = 'urban_mar';
export const RURAL_MAR = 'rural_mar';
export const FACILITY_PROFESSIONAL = 'facility_professional';
export const FACILITY_ASC = 'facility_asc';
export const ACCREDITED = 'accredited';
export const PROFESSIONAL_MAR = 'professional_mar';
export const OP_MAR = 'op_mar';
export const RATE = 'rate';
export const TOTAL = 'total';
export const TOTAL_ALLOWABLE_AMOUNT = 'total_allowable_amount';
export const MAXIMUM_PAYABLE = 'maximum_payable';
export const REIMBURSED = 'reimbursed';
export const NOT_REIMBURSED = 'not_reimbursed';
export const ACH = 'ach';
export const CAH = 'cah';
export const RBRVS = 'rbrvs';
export const RBRVS_FACILITY = 'rbrvs_facility';
export const RBRVS_NON_FACILITY = 'rbrvs_non_facility';
export const MEDICARE_RATE = 'medicare_rate';
export const NON_RURAL = 'non_rural';
export const SUPER_RURAL = 'super_rural';
export const TECHNICAL_COMPONENT = 'technical_component';
export const PROFESSIONAL_COMPONENT = 'professional_component';
export const TECHNICAL_SERVICE = 'technical_service';
export const THIRD_EFF = 'third_eff';
export const TWO_THIRD_EFF = 'two_third_eff';
export const WHOLE_EFF = 'whole_eff';
export const PURCHASED_NEW = 'purchased_new';
export const PURCHASED_USED = 'purchased_used';
export const RENTED = 'rented';
export const INDEX_GROUP_AA = 'index_group_aa';
export const INDEX_GROUP_BB = 'index_group_bb';
export const INDEX_GROUP_CC = 'index_group_cc';
export const INDEX_GROUP_DD = 'index_group_dd';
export const INDEX_GROUP_EE = 'index_group_ee';
export const INDEX_GROUP_FF = 'index_group_ff';
export const INDEX_GROUP_GG = 'index_group_gg';
export const MEDICARE_RURAL = 'medicare_rural';
export const MEDICARE_NON_RURAL = 'medicare_non_rural';

export const OWCP = 'owcp';

export const FINDACODE_FEES = [
  {
    label: 'WC FEE',
    value: WC,
    key: WC,
  },
  {
    label: 'WC FACILITY FEE',
    value: WC_FACILITY,
    key: WC_FACILITY,
  },
  {
    label: 'WC NON FACILITY FEE',
    value: WC_NON_FACILITY,
    key: WC_NON_FACILITY,
  },
  {
    label: 'WC RVU FEE',
    value: WC_RVU,
    key: WC_RVU,
  },
  {
    label: 'WC RVU NON FACILITY FEE',
    value: WC_RVU_NON_FACILITY,
    key: WC_RVU_NON_FACILITY,
  },
  {
    label: 'UCR FEE',
    value: UCR,
    key: UCR,
  },
  {
    label: 'MEDICARE FACILITY',
    value: MEDICARE_ALLOWED,
    key: MEDICARE_ALLOWED,
  },
  {
    label: 'MEDICARE NON-FACILITY',
    value: MEDICARE_BILLED,
    key: MEDICARE_BILLED,
  },
  {
    label: 'MAR',
    value: MAR,
    key: MAR,
  },
  {
    label: 'Urban MAR',
    value: URBAN_MAR,
    key: URBAN_MAR,
  },
  {
    label: 'Rural MAR',
    value: RURAL_MAR,
    key: RURAL_MAR,
  },
  {
    label: 'Facility Professional',
    value: FACILITY_PROFESSIONAL,
    key: FACILITY_PROFESSIONAL,
  },
  {
    label: 'Facility ASC',
    value: FACILITY_ASC,
    key: FACILITY_ASC,
  },
  {
    label: 'Accredited',
    value: ACCREDITED,
    key: ACCREDITED,
  },
  {
    label: 'Professional MAR',
    value: PROFESSIONAL_MAR,
    key: PROFESSIONAL_MAR,
  },
  {
    label: 'OP MAR',
    value: OP_MAR,
    key: OP_MAR,
  },
  {
    label: 'RATE',
    value: RATE,
    key: RATE,
  },
  {
    label: 'TOTAL',
    value: TOTAL,
    key: TOTAL,
  },
  {
    label: 'TOTAL ALLOWABLE AMOUNT',
    value: TOTAL_ALLOWABLE_AMOUNT,
    key: TOTAL_ALLOWABLE_AMOUNT,
  },
  {
    label: 'MAXIMUM PAYABLE',
    value: MAXIMUM_PAYABLE,
    key: MAXIMUM_PAYABLE,
  },
  {
    label: 'REIMBURSED',
    value: REIMBURSED,
    key: REIMBURSED,
  },
  {
    label: 'NOT REIMBURSED',
    value: NOT_REIMBURSED,
    key: NOT_REIMBURSED,
  },
  {
    label: 'ACH',
    value: ACH,
    key: ACH,
  },
  {
    label: 'CAH',
    value: CAH,
    key: CAH,
  },
  {
    label: 'RBRVS',
    value: RBRVS,
    key: RBRVS,
  },
  {
    label: 'RBRVS FACILITY',
    value: RBRVS_FACILITY,
    key: RBRVS_FACILITY,
  },
  {
    label: 'RBRVS NON FACILITY',
    value: RBRVS_NON_FACILITY,
    key: RBRVS_NON_FACILITY,
  },
  {
    label: 'MEDICARE RATE',
    value: MEDICARE_RATE,
    key: MEDICARE_RATE,
  },
  {
    label: 'NON RURAL',
    value: NON_RURAL,
    key: NON_RURAL,
  },
  {
    label: 'SUPER RURAL',
    value: SUPER_RURAL,
    key: SUPER_RURAL,
  },
  {
    label: 'TECHNICAL COMPONENT',
    value: TECHNICAL_COMPONENT,
    key: TECHNICAL_COMPONENT,
  },
  {
    label: 'PROFESSIONAL COMPONENT',
    value: PROFESSIONAL_COMPONENT,
    key: PROFESSIONAL_COMPONENT,
  },
  {
    label: 'TECHNICAL SERVICE',
    value: TECHNICAL_SERVICE,
    key: TECHNICAL_SERVICE,
  },
  {
    label: 'THIRD EFF',
    value: THIRD_EFF,
    key: THIRD_EFF,
  },
  {
    label: 'TWO THIRD EFF',
    value: TWO_THIRD_EFF,
    key: TWO_THIRD_EFF,
  },
  {
    label: 'WHOLE EFF',
    value: WHOLE_EFF,
    key: WHOLE_EFF,
  },
  {
    label: 'PURCHASED NEW',
    value: PURCHASED_NEW,
    key: PURCHASED_NEW,
  },
  {
    label: 'PURCHASED USED',
    value: PURCHASED_USED,
    key: PURCHASED_USED,
  },
  {
    label: 'RENTED',
    value: RENTED,
    key: RENTED,
  },
  {
    label: 'INDEX_GROUP_AA',
    value: INDEX_GROUP_AA,
    key: INDEX_GROUP_AA,
  },
  {
    label: 'INDEX_GROUP_BB',
    value: INDEX_GROUP_BB,
    key: INDEX_GROUP_BB,
  },
  {
    label: 'INDEX_GROUP_CC',
    value: INDEX_GROUP_CC,
    key: INDEX_GROUP_CC,
  },
  {
    label: 'INDEX_GROUP_DD',
    value: INDEX_GROUP_DD,
    key: INDEX_GROUP_DD,
  },
  {
    label: 'INDEX_GROUP_EE',
    value: INDEX_GROUP_EE,
    key: INDEX_GROUP_EE,
  },
  {
    label: 'INDEX_GROUP_FF',
    value: INDEX_GROUP_FF,
    key: INDEX_GROUP_FF,
  },
  {
    label: 'INDEX_GROUP_GG',
    value: INDEX_GROUP_GG,
    key: INDEX_GROUP_GG,
  },
  {
    label: 'MEDICARE RURAL',
    value: MEDICARE_RURAL,
    key: MEDICARE_RURAL,
  },
  {
    label: 'MEDICARE NON RURAL',
    value: MEDICARE_NON_RURAL,
    key: MEDICARE_NON_RURAL,
  },
];

export const OWCP_FEES = [
  {
    label: 'OWCP RATE',
    value: OWCP,
    key: OWCP,
  },
];

export const PERCENTAGES = [
  {
    label: '80%',
    value: 0.8,
  },
  {
    label: '100%',
    value: 1,
  },
  {
    label: '120%',
    value: 1.2,
  },
];
